var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Form from 'antd/lib/form';
import InputNumber from 'antd/lib/input-number';
import 'antd/lib/input-number/style/index.css';
var FormAthleteScoreItem = (function (_super) {
    __extends(FormAthleteScoreItem, _super);
    function FormAthleteScoreItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            checkUnique: undefined,
        };
        return _this;
    }
    FormAthleteScoreItem.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(Form.Item, { label: React.createElement("span", null,
                    "Bib Number for ",
                    React.createElement("strong", null, this.props.round.name)), hasFeedback: this.state.checkUnique !== undefined, validateStatus: this.props.form.getFieldsError(["athleteScores[" + this.props.index + "][bibNumber]"]).subdomain ? 'error' : this.state.checkUnique, help: this.state.checkUniqueError, colon: false }, this.props.form.getFieldDecorator("athleteScores[" + this.props.index + "][bibNumber]", {
                initialValue: this.props.athleteScoreDoc.bibNumber,
                rules: [{
                        required: true,
                        message: 'Please set a bib number',
                    }, {
                        type: 'integer',
                        message: 'Please use numbers',
                    }],
            })(React.createElement(InputNumber, { size: 'large', min: 1, max: 999, style: { width: '100%' }, disabled: this.props.isDisabled, onChange: function (value) {
                    if (!Number.isInteger(value)) {
                        return;
                    }
                    var isUnique = _this.props.checkBibNumberIsUnique(_this.props.athleteScoreDoc.bibNumber, value, _this.props.round.id);
                    _this.setState({
                        checkUnique: isUnique ? 'success' : 'error',
                        checkUniqueError: isUnique ? '' : 'Bib number has been used in this round',
                    });
                } }))),
            this.props.form.getFieldDecorator("athleteScores[" + this.props.index + "][id]", {
                initialValue: this.props.athleteScoreDoc.id,
            })(React.createElement(React.Fragment, null)),
            this.props.form.getFieldDecorator("athleteScores[" + this.props.index + "][roundId]", {
                initialValue: this.props.round.id,
            })(React.createElement(React.Fragment, null)),
            this.props.form.getFieldDecorator("athleteScores[" + this.props.index + "][scoreSystem]", {
                initialValue: this.props.round.scoreSystem,
            })(React.createElement(React.Fragment, null))));
    };
    return FormAthleteScoreItem;
}(React.Component));
export default FormAthleteScoreItem;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthletePage/FormAthleteScore/FormAthleteScoreItem.tsx
// module id = 1209
// module chunks = 0